import React from "react";

const Privacy = () => {
  return (
    <section class="legal-container">
      <h1>Privacy Policy</h1>
      <p>
        <strong>AlFurqan International</strong>
      </p>
      <p>
        <em>Last updated: January 2026</em>
      </p>

      <p>
        AlFurqan International ("we", "our", or "us") is committed to protecting
        your privacy. This Privacy Policy explains how we collect, use,
        disclose, and safeguard your information when you use our website,
        applications, and services (the "Services").
      </p>

      <h2>1. Information We Collect</h2>

      <h3>Personal Information</h3>
      <ul>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Profile image</li>
        <li>Login credentials (encrypted)</li>
        <li>Payment or transaction details (if applicable)</li>
      </ul>

      <h3>Automatically Collected Information</h3>
      <ul>
        <li>IP address</li>
        <li>Browser and device information</li>
        <li>Usage data and pages visited</li>
        <li>Cookies and tracking technologies</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Create and manage user accounts</li>
        <li>Authenticate users</li>
        <li>Provide and improve our services</li>
        <li>Communicate updates and support messages</li>
        <li>Ensure security and prevent fraud</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h2>3. Cookies</h2>
      <p>
        We use cookies to maintain sessions, analyze usage, and enhance user
        experience. You can disable cookies via your browser, but some features
        may not function properly.
      </p>

      <h2>4. Sharing of Information</h2>
      <p>
        We do not sell your personal data. Information may be shared only with:
      </p>
      <ul>
        <li>Trusted service providers</li>
        <li>Legal authorities when required by law</li>
        <li>Partners strictly necessary to deliver services</li>
      </ul>

      <h2>5. Social Login</h2>
      <p>
        If you sign in using third-party providers (e.g., Google), we may
        receive basic profile details such as name and email. We never receive
        your social account password.
      </p>

      <h2>6. Data Security</h2>
      <p>
        We use industry-standard security measures including encryption and
        secure access controls. However, no system is completely secure.
      </p>

      <h2>7. Data Retention</h2>
      <p>
        We retain personal data only for as long as necessary to fulfill service
        and legal requirements.
      </p>

      <h2>8. Your Rights</h2>
      <p>
        You may request access, correction, or deletion of your personal
        information by contacting us.
      </p>

      <h2>9. Children’s Privacy</h2>
      <p>Our services are not intended for children under the age of 13.</p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        <strong>AlFurqan International</strong>
        <br />
        Email: support@alfurqaninternational.org
        <br />
        Website: https://alfurqaninternational.org
      </p>
    </section>
  );

};

export default Privacy;
